var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',[_c('canvas',{attrs:{"id":_vm.chartID,"aria-label":"Chart","role":"img"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }